import { BasketTransferError } from '@repo/ui/src/utils/errors';
import { GraphQLRequestWithTokenProps, requestWithToken } from '@repo/ui/src/utils/graphql-request';
import { Variables as DefaultVariables } from 'graphql-request/dist/types';

export const basketRequest = async <
  Data = any,
  Variables extends DefaultVariables = DefaultVariables,
>(
  props: GraphQLRequestWithTokenProps<Variables>,
) => {
  try {
    return await requestWithToken<Data, Variables>(props);
  } catch (e) {
    throw new BasketTransferError();
  }
};

export class OutOfStockError extends Error {
  info;
  constructor(info: any) {
    super('Out of Stock');
    this.info = info;
  }
}
